import { useState } from 'react';

export const useCheckoutModals = () => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [isSmartphoneInstructionsModalOpen, setIsSmartphoneInstructionsModalOpen] = useState(false);
  const [isQiCardInstructionsModalOpen, setIsQiCardInstructionsModalOpen] = useState(false);

  const handleOpenSmartphoneModal = () => setIsSmartphoneInstructionsModalOpen(true);
  const handleOpenQiCardInstructionsModal = () => setIsQiCardInstructionsModalOpen(true);
  const handleCloseModal = () => {
    setIsSmartphoneInstructionsModalOpen(false);
    setIsQiCardInstructionsModalOpen(false);
  };
  const handleCloseAuthModal = () => setIsAuthModalOpen(false);
  const handleOpenAuthModal = () => setIsAuthModalOpen(true);

  return {
    isAuthModalOpen,
    isSmartphoneInstructionsModalOpen,
    isQiCardInstructionsModalOpen,
    handleOpenSmartphoneModal,
    handleOpenQiCardInstructionsModal,
    handleCloseModal,
    handleCloseAuthModal,
    handleOpenAuthModal,
  };
};
